import React, { useEffect, useState } from 'react';
import { Container, Grid, Paper, Typography, Button, Box, Divider, TextareaAutosize } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ContactPhoneOutlinedIcon from '@mui/icons-material/ContactPhoneOutlined';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import { styled } from '@mui/material/styles';
import { Address, Billing, Contact, Copy, Customer, CustomerInfo, Edits, EmailBox, Payment, Phone, Shipping, Users } from '../../../Svg';
import NestedUserHeader from '../../../component/reusable/NestedUserHeader';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getAllAdminThunk } from '../../../redux/admin/adminSlice';
import { getVendorDetailsThunk, vendorrejectOrAproveThunk } from '../../../redux/vendor/vendorSlice';
import { handleCopy } from '../../../utils/fomateDate';
import AssignModal from '../../../component/reusable/assignModal/AssignModal';
import { editRemarksThunk } from '../../../redux/customer/customerSlice';


const StyledGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: theme.shape.borderRadius,
}));

const VendorDetails = () => {


  const { loading, vendorDetails, refresh, statusLoading } = useSelector((state) => state.vendor);
  const { admin } = useSelector((state) => state?.admin)
  const [selectedAdmin, setAdmin] = useState(null)
  const [asignopen, setAsign] = useState(false)
  const dispatch = useDispatch()
  const [remarks, setRemarks] = useState('')
  const { id } = useParams()


  useEffect(() => {
    dispatch(getVendorDetailsThunk(id))
    dispatch(getAllAdminThunk())
  }, [refresh])



  useEffect(() => {
    if (vendorDetails?.remarks) {
      setRemarks(vendorDetails?.remarks)
    }
  }, [vendorDetails])

  const rejectOrAprove = (status) => {

    const data = {
      id,
      status,
      selectedAdmin
    }
    setAsign(false)
    dispatch(vendorrejectOrAproveThunk(data))
  }

  const handleRemarkEditClick = async () => {
    const data = {
      id,
      values: { remarks }
    }
    dispatch(editRemarksThunk(data))
  }

  return (
    <>
      <NestedUserHeader
        index="Vendors details"
        root="Dashboard"
        buttonText={'Add Subcategory'}
      />

      {loading ? <div>Please wait...</div> :
        <Box maxWidth="lg">
          {vendorDetails?.status === "PENDING" ?
            <Paper sx={{ p: 2, mb: 2, boxShadow: '0px 1px 0px 0px #E5E5E5' }}>
              <StyledGrid container>
                <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography sx={{ fontSize: "20px", color: '#1A1A1A', paddingRight: '5px' }}>Approval </Typography>
                  <Typography sx={{ fontSize: "14px", color: '#4D4D4D' }}>
                    &bull; Registered date: 25 Sept 24 &bull; <span style={{ color: '#E9BD21' }}>Pending</span>
                  </Typography>
                </Grid>
                {statusLoading ? <div>Please wait...</div> :
                  <Grid item sx={{ display: 'flex', gap: 1 }}> {/* Adds space between buttons */}
                    <Button sx={{ color: '#E95555', fontSize: "14px", textTransform: 'capitalize' }} onClick={() => rejectOrAprove('REJECTED')}>Reject</Button>
                    <Button variant="contained" sx={{ color: '#fff', fontSize: "14px", textTransform: 'capitalize', background: '#2DA85E' }} onClick={() => setAsign(true)}>Approve</Button>
                  </Grid>
                }
              </StyledGrid >
            </Paper>
            : null}
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Paper sx={{ height: '100%', boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>

                <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                  <CustomerInfo />
                  <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                    Vendor Info
                  </Typography>
                </Box>

                <Divider sx={{ mb: 1 }} />

                <Box sx={{ p: 3, }} display="flex" alignItems="flex-start" >
                  <Customer />
                  <Box style={{ marginLeft: '8px', }}>
                    <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                      Vendor
                    </Typography>
                    <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                      {vendorDetails?.companyName}
                    </Typography></Box>
                </Box>

                <Box sx={{ p: 3, paddingTop: 0 }} display="flex" alignItems="flex-start" >
                  <Customer />
                  <Box style={{ marginLeft: '8px', }}>
                    <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                      Name
                    </Typography>
                    <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                      {vendorDetails?.fullName}
                    </Typography></Box>
                </Box>

              </Paper>
            </Grid>


            <Grid item xs={12} md={6}>
              <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                  <Contact />
                  <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                    Contact
                  </Typography>
                </Box>
                <Divider sx={{ mb: 1 }} />
                <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                  <Box display="flex" >
                    <EmailBox />
                    <Box style={{ marginLeft: '8px', }}>
                      <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                        Email
                      </Typography>
                      <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                        {vendorDetails?.email}
                      </Typography>
                    </Box>
                  </Box>
                  <Box>
                    <div onClick={() => handleCopy(vendorDetails?.email)}>
                      <Copy />
                    </div>
                  </Box>
                </Box>
                <Box sx={{ p: '24px 24px 24px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                  <Box display="flex" >
                    <Phone />
                    <Box style={{ marginLeft: '8px', }}>
                      <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                        Phone Number
                      </Typography>
                      <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                        {vendorDetails?.phone}
                      </Typography>
                    </Box>
                  </Box>
                  <Box>
                    <div onClick={() => handleCopy(vendorDetails?.phone)}>
                      <Copy />
                    </div>
                  </Box>
                </Box>
              </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
              <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                  <Payment />
                  <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                    Payment
                  </Typography>
                </Box>
                <Divider sx={{ mb: 1 }} />
                <Box sx={{ p: 3, }} display="flex" alignItems="flex-start" >
                  <Billing />
                  <Box style={{ marginLeft: '8px', }}>
                    <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                      Billing Address
                    </Typography>
                    {vendorDetails?.billingAddress?.map((i) => (
                      <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                        {i?.factoryUnits}<br />
                        {i?.streetAddress}, {i?.state},{i?.country} - {i?.zipCode}
                      </Typography>
                    ))
                    }
                  </Box>
                </Box>
              </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
              <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                  <Shipping />
                  <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                    Shipping
                  </Typography>
                </Box>
                <Divider sx={{ mb: 1 }} />
                <Box sx={{ p: 3, }} display="flex" alignItems="flex-start" >
                  <Address />
                  <Box style={{ marginLeft: '8px', }}>
                    <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                      Shipping Address
                    </Typography>
                    {vendorDetails?.shippingAddress?.map((i) => (

                      <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                        {i?.factoryUnits}<br />
                        {i?.streetAddress}, {i?.state},{i?.country} - {i?.zipCode}
                      </Typography>
                    ))
                    }</Box>
                </Box>
              </Paper>
            </Grid>


            <Grid item xs={12} md={6}>
              <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                  <Shipping />
                  <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                    Manufacturers
                  </Typography>
                </Box>
                <Divider sx={{ mb: 1 }} />
                <Box sx={{ p: 3, }} display="flex" alignItems="flex-start" >
                  <Users />
                  <Box style={{ marginLeft: '8px', }}>
                    <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                      Manufacturers
                    </Typography>
                    {vendorDetails?.manufacturers?.map((i) => (

                      <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                        {i?.name}<br />
                      </Typography>
                    ))
                    }</Box>
                </Box>
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                <Box sx={{ p: 2, }} display="flex" alignItems="center" justifyContent={'space-between'} >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Users />
                    <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                      Remarks
                    </Typography>
                  </div>
                  <div style={{ marginLeft: '10px', fontSize: '18px', cursor: 'pointer' }} onClick={handleRemarkEditClick} >
                    <Edits />
                  </div>

                </Box>
                <Divider sx={{ mb: 1 }} />
                <Box sx={{ p: 2, }} display="flex" alignItems="flex-start" gap='20px'>
                  {/* <Textarea placeholder="Placeholder" minRows={2} /> */}
                  <TextareaAutosize
                    aria-label="minimum height"
                    minRows={5}
                    placeholder="Add remarks here"
                    onChange={(e) => setRemarks(e.target.value)}
                    value={remarks}
                    style={{
                      width: "100%",
                      padding: 10,
                      border: "1px solid #D9E1EC",
                      outline: "none",
                      resize: "none",
                      borderRadius: 7
                    }}
                  />
                </Box>
              </Paper>
            </Grid>
          </Grid>

          <AssignModal
            isOpen={asignopen}
            onClose={() => setAsign(false)}
            onAssign={() => rejectOrAprove('APPROVED')}
            heading={'Vendor'}
            admin={admin}
            name={vendorDetails?.fullName}
            setAdmin={setAdmin}
            selectedAdmin={selectedAdmin}
            statusLoading={statusLoading}
          />
        </Box>
      }
    </>
  );
};

export default VendorDetails;
